export const FETCHING_ORIGINS = '@@toyota/FETCHING_ORIGINS';
export const FETCHED_ORIGINS = '@@toyota/FETCHED_ORIGINS';
export const FETCHED_ORIGINS_FAILED = '@@toyota/FETCHED_ORIGINS_FAILED';

export const FETCHING_PROVIDERS = '@@toyota/FETCHING_PROVIDERS';
export const FETCHED_PROVIDERS = '@@toyota/FETCHED_PROVIDERS';
export const FETCHED_PROVIDERS_FAILED = '@@toyota/FETCHED_PROVIDERS_FAILED';

export const ADDING_ORIGINS = '@@toyota/ADDING_ORIGINS';
export const ADDED_ORIGINS = '@@toyota/ADDED_ORIGINS';
export const ADD_ORIGINS_FAILED = '@@toyota/ADD_ORIGINS_FAILED';

export const DELETING_ORIGINS = '@@toyota/DELETING_ORIGINS';
export const DELETED_ORIGINS = '@@toyota/DELETED_ORIGINS';
export const DELETE_ORIGINS_FAILED = '@@toyota/DELETE_ORIGINS_FAILED';

export const FETCHING_XLXS_ORDER_FILE = '@@toyota/FETCHING_XLXS_ORDER_FILE';
export const FETCHED_XLXS_ORDER_FILE = '@@toyota/FETCHED_XLXS_ORDER_FILE';
export const FETCH_XLXS_ORDER_FILE_FAILED = '@@toyota/FETCH_XLXS_ORDER_FILE_FAILED';

export const FETCHING_CREATE_HEADER_AND_DATA = '@@toyota/FETCHING_CREATE_HEADER_AND_DATA';
export const FETCHED_CREATE_HEADER_AND_DATA = '@@toyota/FETCHED_CREATE_HEADER_AND_DATA';
export const FETCH_CREATE_HEADER_AND_DATA_FALIED = '@@toyota/FETCH_CREATE_HEADER_AND_DATA_FALIED';

export const FETCHING_ORIGINS_MENU = '@@toyota/FETCHING_ORIGINS_MENU';
export const FETCHED_ORIGINS_MENU = '@@toyota/FETCHED_ORIGINS_MENU';
export const FETCH_ORIGINS_MENU_FAILED = '@@toyota/FETCH_ORIGINS_MENU_FAILED';

export const FETCHING_ALL_DATA_ORIGINS = '@@toyota/FETCHING_ALL_DATA_ORIGINS';
export const FETCHED_ALL_DATA_ORIGINS = '@@toyota/FETCHED_ALL_DATA_ORIGINS';
export const FETCH_ALL_DATA_ORIGINS_FAILED = '@@toyota/FETCH_ALL_DATA_ORIGINS_FAILED';

export const FETCHING_ADD_ALL_DATA_ORIGINS = '@@toyota/FETCHING_ADD_ALL_DATA_ORIGINS';
export const FETCHED_ADD_ALL_DATA_ORIGINS = '@@toyota/FETCHED_ADD_ALL_DATA_ORIGINS';
export const FETCH_ADD_ALL_DATA_ORIGINS_FAILED = '@@toyota/FETCH_ADD_ALL_DATA_ORIGINS_FAILED';


export const FETCHING_ALL_MODELS_CATALOG = '@@toyota/FETCHING_ALL_MODELS_CATALOG';
export const FETCHED_ALL_MODELS_CATALOG = '@@toyota/FETCHED_ALL_MODELS_CATALOG';
export const FETCH_ALL_MODELS_CATALOG_FAILED = '@@toyota/FETCH_ALL_MODELS_CATALOG_FAILED';

export const FETCHING_ADD_TEMP_ORDER = '@@toyota/FETCHING_ADD_TEMP_ORDER';
export const FETCHED_ADD_TEMP_ORDER = '@@toyota/FETCHED_ADD_TEMP_ORDER';
export const FETCH_ADD_TEMP_ORDER_FALIED = '@@toyota/FETCH_ADD_TEMP_ORDER_FALIED';


export const ACTIVATE_ORIGIN_EDIT = '@@toyota/ACTIVATE_ORIGIN_EDIT';
export const DESACTIVATE_ORIGIN_EDIT = '@@toyota/DESACTIVATE_ORIGIN_EDIT';

export const SET_HEADER_VALUE = '@@toyota/SET_HEADER_VALUE';
export const CLEAN_HEADER_VALUE = '@@toyota/CLEAN_HEADER_VALUE';

export const UPLOAD_ORDER_FILE = '@@toyota/UPLOAD_ORDER_FILE';
export const REMOVE_ORDER_FILE = '@@toyota/REMOVE_ORDER_FILE';

export const UPLOAD_ORDER_RAW_FILE = '@@toyota/UPLOAD_ORDER_RAW_FILE';
export const REMOVE_ORDER_RAWFILE = '@@toyota/REMOVE_ORDER_RAWFILE';

export const SET_VALID_ORDER_TRUE = '@@toyota/SET_VALID_ORDER_TRUE';
export const SET_VALID_ORDER_FALSE = '@@toyota/SET_VALID_ORDER_FALSE';

export const SET_CREATE_ORDER_PRICE = '@@toyota/SET_CREATE_ORDER_PRICE';

export const SET_ORDER = '@@toyota/SET_ORDER';

export const ADD_NOTIFICATION_ORDER = '@@toyota/ADD_NOTIFICATION_ORDER';

export const SET_ORDER_PROCESSED_DATA = '@@toyota/SET_ORDER_PROCESSED_DATA';

export const CLEAN_CREATE_ORDER = '@@toyota/CLEAN_CREATE_ORDER';

export const DUMMY_ACTION = '@@toyota/CLEAN_CREATE_ORDER';

export const ADD_TEMP_ORDER = '@@toyota/ADD_TEMP_ORDER';
export const UPDATE_TEMP_ORDER = '@@toyota/UPDATE_TEMP_ORDER';
export const REMOVE_TEMP_ORDER = '@@toyota/REMOVE_TEMP_ORDER';
export const CLEAN_TEMP_ORDER = '@@toyota/CLEAN_TEMP_ORDER';

export const SET_SHOW_SHIPMENT_HEADER = '@@toyota/SET_SHOW_SHIPMENT_HEADER';

export const SET_SHIPMENT_VALUES = '@@toyota/SET_SHIPMENT_VALUES';

export const SET_ORDER_FROM_SHIPMENT_TABLE = '@@toyota/SET_ORDER_FROM_SHIPMENT_TABLE';

export const FETCHING_GET_SHIPMENT_HEADER = '@@toyota/FETCHING_GET_SHIPMENT_HEADER';
export const FETCHED_GET_SHIPMENT_HEADER = '@@toyota/FETCHED_GET_SHIPMENT_HEADER';
export const FETCH_GET_SHIPMENT_HEADER_FAILED = '@@toyota/FETCH_GET_SHIPMENT_HEADER_FAILED';

export const FETCHING_GET_SHIPMENT_DATA = '@@toyota/FETCHING_GET_SHIPMENT_DATA';
export const FETCHED_GET_SHIPMENT_DATA = '@@toyota/FETCHED_GET_SHIPMENT_DATA';
export const FETCH_GET_SHIPMENT_DATA_FAILED = '@@toyota/FETCH_GET_SHIPMENT_DATA_FAILED';

export const FETCHING_POST_SHIPMENT_DATA = '@@toyota/FETCHING_POST_SHIPMENT_DATA';
export const FETCHED_POST_SHIPMENT_DATA = '@@toyota/FETCHED_POST_SHIPMENT_DATA';
export const FETCH_POST_SHIPMENT_DATA_FALIED = '@@toyota/FETCH_POST_SHIPMENT_DATA_FALIED';

export const CLEAN_SHIPMENT_HEADER = '@@toyota/CLEAN_SHIPMENT_HEADER';

export const SET_UPDATE_SHIPMENT_HEADER = '@@toyota/SET_UPDATE_SHIPMENT_HEADER';
export const SET_SHOW_SHIPMENT_HEADER_SHIP = '@@toyota/SET_SHOW_SHIPMENT_HEADER_SHIP';

export const UPDATE_SHIPMENT_TABLE = '@@toyota/UPDATE_SHIPMENT_TABLE';
export const CLEAN_SHIPMENT_TABLE = '@@toyota/CLEAN_SHIPMENT_TABLE';

export const FETCHING_GET_ORDER_SUMMARY = '@@toyota/FETCHING_GET_ORDER_SUMMARY';
export const FETCHED_GET_ORDER_SUMMARY = '@@toyota/FETCHED_GET_ORDER_SUMMARY';
export const FETCH_GET_ORDER_SUMMARY_FAILED = '@@toyota/FETCH_GET_ORDER_SUMMARY_FAILED';
